'use client'

import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      // An open drawer or dialog makes the rest of the page ignore clicks; a toast (Undo, a link) must still take them.
      toastOptions={{ className: 'pointer-events-auto' }}
      // Clear the iOS home indicator (needs viewport-fit=cover, set in app/layout), and the
      // session flow's bottom action bar while one is on screen (components/encounters/mobile-action-bar).
      mobileOffset={{ bottom: 'calc(max(16px, env(safe-area-inset-bottom)) + var(--mobile-action-bar, 0px))' }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
